export const founders = [
  {
    name: 'Davide Barenghi',
    position: 'CEO',
    description:
      "Davide è stato attivo come imprenditore nella sanità digitale negli ultimi 5 anni. In precedenza è stato Amministratore Delegato di Azimut investimenti in Brasile. È Laureato a pieni voti in Diritto Societario presso l'Università Bocconi e ha fatto un Master presso la Westminster University (Londra).",
  },
  {
    name: 'Chiara Frigerio',
    position: 'CMO',
    description:
      "Chiara ha oltre 15 anni di esperienza nel campo della comunicazione digitale e dei media, prima in UK e poi in Italia. Negli ultimi 10 anni ha ricoperto ruoli nel Digital Marketing e Business Development in RCS e Italiaonline. E’ laureata con lode in'Università Cattolica (Milano) e ha un MA alla Goldsmith University (Londra).",
  },
  {
    name: 'Tommaso de Mojana',
    position: 'COO',
    description:
      "Tommaso è stato un Senior Manager nel settore del FMCG spendendo circa 15 anni nei dipartimenti di Trade Marketing, Sales e Operations di importanti multinazionali del largo consumo. Tommaso è laureato in Scienze Politiche e Comunicazione presso l'Università degli Studi di Milano.",
  },
];
